module.exports = __webpack_public_path__ + "img/slika16.d46a10e5.jpg";